import { render } from "./AddFacadeInGalleryModal.vue?vue&type=template&id=a6884d5a&scoped=true&ts=true&lang=pug"
import script from "./AddFacadeInGalleryModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddFacadeInGalleryModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddFacadeInGalleryModal.vue?vue&type=style&index=0&id=a6884d5a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6884d5a"]])

export default __exports__